<template>
  <div class="material">
    <el-row :gutter="20" style="position: relative;">
      <div class="moblie-show classification-class" :class="{'classification-class-2': showClassification}" @click="showClassification=!showClassification"><i class="el-icon-s-unfold"></i><br/>饲<br/>料<br/>原<br/>料<br/>分<br/>类</div>
      <el-col :span="5" :class="{'openSection': showClassification}">
        <div style="height: 100%;" @click="showClassification=!showClassification">
          <div class="grid-content" @click.stop="">
            <v-navbar :navlist="leftMenu.navList2" @itemfun='parentEvent'></v-navbar>
          </div>
        </div>
      </el-col>
      <el-col :span="19">
        <div class="grid-content" :class="{'inner-box': isInnerBox}" :style="materialHeight">
          <h2>{{$route.query.name}}</h2>
          <el-form :inline="true" :model="searchValue" :rules="rules" ref="searchValue" label-width="100px" class="demo-ruleForm" :class="{flex:isFlex}" >
            <el-form-item label="分类" prop="first_catname">
              <!-- <el-select v-model="searchValue.first_catname" placeholder="请选择分类">
                <el-option v-for="(item,index) in leftMenu.navList" :key="index" :label="item.catname" :value="item.catid"></el-option>
              </el-select> -->
			  <el-cascader
				  v-model="searchValue.first_catname"
			      :options="leftMenu.navList2"
				  :show-all-levels="false"
			      :props="{
					  checkStrictly: true,
					  value: 'catid',
					  label: 'catname',
					  children: 'children',
					  emitPath: false,
				  }"
				  placeholder="请选择分类"
			      clearable>
			  </el-cascader>
            </el-form-item>
            <el-form-item label="原料名称" prop="title">
              <el-input v-model="searchValue.title" placeholder="请输入关键词" @keyup.enter.native="submitForm('searchValue')"></el-input>
            </el-form-item>
            <el-form-item label="特征描述" prop="content">
              <el-input v-model="searchValue.content"  placeholder="请输入关键词" @keyup.enter.native="submitForm('searchValue')"></el-input>
            </el-form-item>
            <el-form-item class="search-2">
              <el-button type="primary" @click="submitForm('searchValue')">搜索</el-button>
              <el-button @click="resetForm('searchValue')">重置</el-button>
            </el-form-item>
          </el-form>
          <!-- pc端表格 -->
          <el-table
          class="pc-show"
          v-loading="loading"
          :header-cell-style="{background:'rgba(248, 248, 248, 0.39)'}"
          :data="tableData"
          border
          stripe
          style="width: 100%">
          <el-table-column
            prop="ylcode"
            label="原料编号"
            min-width="10%">
          </el-table-column>
          <el-table-column
            prop="ENname"
            label="原料名称"
            min-width="20%">
            <template slot-scope="scope">
              <div v-html="scope.row.title" class="button-title" @click="toDetail(scope.row.itemid)"></div>
              <!-- <router-link :to="{name: 'materialArticle', query:{itemid:scope.row.itemid}}"><div v-html="scope.row.title"></div></router-link> -->
            </template>
          </el-table-column>
          <el-table-column
            prop="bsyq"
            label="强制性标识要求"
            min-width="25%">
            <template slot-scope="scope">
              <div v-html="scope.row.bsyq"></div>
            </template>
            </el-table-column>
          <el-table-column
            prop="content"
            label="特征描述"
            min-width="45%">
          </el-table-column>
          </el-table>
          <!-- 手机端表格 -->
          <el-table
          class="moblie-show"
          v-loading="loading"
          :header-cell-style="{background:'rgba(248, 248, 248, 0.39)'}"
          :data="tableData"
          border
          stripe
          style="width: 100%">
          <el-table-column
            fixed="left"
            prop="ENname"
            label="原料名称"
            width="100px">
            <template slot-scope="scope">
              <div v-html="scope.row.title" class="button-title" @click="toDetail(scope.row.itemid)"></div>
              <!-- <router-link :to="{name: 'materialArticle', query:{itemid:scope.row.itemid}}"><div v-html="scope.row.title"></div></router-link> -->
            </template>
          </el-table-column>
          <el-table-column
            prop="ylcode"
            label="原料编号"
            width="80px">
          </el-table-column>
          <el-table-column
            prop="bsyq"
            label="强制性标识要求"
            width="100px">
            <template slot-scope="scope">
              <div v-html="scope.row.bsyq"></div>
            </template>
            </el-table-column>
          <el-table-column
            prop="content"
            label="特征描述"
            width="200px">
          </el-table-column>
          </el-table>

          <div class="block">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="current_page"
              :page-sizes="[10, 30, 50]"
              :page-size="per_page"
              layout="total, prev, pager, next, sizes, jumper"
              :total="total">
            </el-pagination>
          </div>

        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import navbar from './navbar.vue'
export default {
  name: 'material',
  data() {
    let checkwhitename = (rule, value, callback) => {
      if (!this.searchValue.first_catname && !this.searchValue.title && !this.searchValue.content) {
        return callback(new Error("请至少填写一项"))
      }else{
        return callback();
      }
    };
    return {
      searchValue: {
        title:'',
        content:'',
        first_catname:'',
        catid:'',
      },
      materialHeight: {
        minHeight: ''
      },
      isInnerBox: true,
      isFlex: true,

      rules: {
        // first_catname: [
        //   { validator: checkwhitename, trigger: 'blur' },
        // ],
        // title: [
        //   { validator: checkwhitename, trigger: 'blur' },
        //   { max: 20, message: '原料名称不能超过 20 个字符', trigger: 'blur' ,validator: checkwhitename,}
        // ],
        // content: [
        //   { validator: checkwhitename, trigger: 'blur' },
        // ],
      },
      tableData: [],
      leftMenu: {
        navList: [],
        navList2: []
      },
      current_page: 1,
      per_page: 10,
      total: 10,
      loading: true,
      showClassification: false,
    };
  },
  components: {
    'v-navbar':navbar
  },
	activated() {
		this.searchValue= {
		  title:'',
		  content:'',
		  first_catname:'',
		  catid:''
		},
	  this.initTableData();
	},
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //alert('submit!');
		  this.current_page = 1
          this.initTableData();
        } else {
          this.$message.error('请输入正确的搜索内容');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.initTableData();
    },
    handleSizeChange(val) {
			this.current_page = 1
      this.per_page = val
      this.initTableData();
    },
    handleCurrentChange(val) {
      this.current_page = val;
      this.initTableData();
    },
    initNavList(){
      this.$ajax.get('https://api.sy.foodvip.net/?c_key=de5cd2297c84684b&func_name=feed_ngredients_cate&type=2').then(resp=>{
        if(resp){
          let navList = resp.data.data;
      	var navList2 = []
      	navList.forEach(item => {
      		if(item.parentid == 0){
      			navList2.push({
      				...item,
      				children:[]
      			})
      		}
      	})
      	navList2.forEach(item =>{
      		navList.forEach(item2 =>{
      			if(item2.parentid == item.catid){
      				item.children.push({
      					...item2
      				})
      			}
      		})
      	})
			this.leftMenu.navList = navList
			this.leftMenu.navList2 = navList2
        }
      })
    },
    initTableData(){
      this.loading = true;
      this.$ajax.get('https://api.sy.foodvip.net/?c_key=de5cd2297c84684b&func_name=feed_ngredients_list&title=' + this.title + '&content=' + this.content + '&catid' + this.catid,{
        params: {
          title: this.searchValue.title,
          content: this.searchValue.content,
          catid: this.searchValue.first_catname,
          page: this.current_page,
          num: this.per_page,
        }
      }).then(resp=>{
        this.loading = false ;
        if(resp){
          this.tableData = resp.data.data.data ;
          this.total = resp.data.data.total;
        }
      })
    },
    parentEvent(val) {
      //接收navbar组件传递的catid
	  this.searchValue= {
	    title:'',
	    content:'',
	    first_catname:'',
	    catid:''
	  },
      this.searchValue.first_catname = Number(val);
      this.initTableData();
    },
	toDetail(itemid){
		const routeUrl = this.$router.resolve({
        name: 'materialArticle',
        query: { itemid: itemid, current: 3 }
      })
      window.open(routeUrl.href, '_blank')
	}
  },
  mounted() {
    this.materialHeight.minHeight = (parseInt(window.innerHeight) - 200) + "px";
    this.initNavList();
  },
}
</script>

<style scoped>
.button-title{color: #2469B7;cursor: pointer;}
.material{
  position: relative;
  width: calc(100% + 120px);
  margin-left: -60px;
  margin-top: -30px;
  background-color: #f7f7f7;
  overflow: hidden;
}
.material > .el-row{
  display: flex;
}
.material > .el-row > .el-col.el-col-5 > div > .grid-content{
  height: 100%;
  padding: 0 10px;
  background-color: #fff;
}
.inner-box{
  margin: 20px 20px 0 0;
  padding: 10px 40px 40px;
  background: #fff;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
  border-radius: 5px 5px 0 0;
  box-sizing: border-box;
}
form.el-form{
  margin-bottom: 20px;
}

@media screen and (max-width:1440px) {
  .flex{
    display: flex;
    flex-wrap: wrap;
    justify-content:space-around;
  }
}
.cell a{
  color: #2469B7;
  text-decoration: none;
}
@media screen and (max-width: 750px) {
  h2{
    padding: 0;
  }
  .el-col.el-col-5{
    position: fixed;
    top: 0;
    right: auto;
    bottom: 0;
    left: -750PX;
    width: auto;
    padding: 0 !important;
    overflow: auto;
    z-index: 999;
    transition: all 0.3s;
  }
  .el-col.el-col-5.openSection{
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: all 0.3s ease-out;
  }
  .el-col.el-col-5.openSection > div{
    background-color: rgba(0, 0, 0, 0.3);
  }
  .material{
    width: 100%;
    margin: 0;
    background-color: #fff;
  }
  .material > .el-row{
    margin: 0 !important;
  }
  .el-col-19{
    width: 100%;
    padding: 0 !important;
  }
  .inner-box{
    margin: 0;
    padding: 0 0 40px;
    background: #fff;
    box-shadow: none;
    border-radius: 0;
    box-sizing: border-box;
  }
  .search-2 /deep/ .el-form-item__content{
    display: flex;
    justify-content: flex-end;
  }
  .search-2 /deep/ .el-form-item__content button{
    width: 100px;
  }
  .material > .el-row > .el-col.el-col-5 > div > .grid-content{
    width: 70%;
    background-color: #fff;
    overflow-y: auto;
  }
  .classification-class{
    position: fixed;
    left: 0px;
    top: 45%;
    padding: 8px;
    font-size: 14px;
    color: #666;
    line-height: 1.1;
    background-color: rgb(255, 255, 255);
    box-shadow: 0 1px 6px rgba(0, 0, 0, .3);
    border-radius: 0 4px 4px 0;
    z-index: 99;
  }
  .classification-class i{
    margin-bottom: 4px;
    font-size: 16px;
    color: #2469B7;
  }
  .classification-class-2{
    left: calc(70% + 20px);
    z-index: 9999;
    box-shadow: none;
    transition: all 0.4s;
  }
  .classification-class-2 i{
    transform: rotate(180deg);
  }
}
</style>
<style>
@media screen and (max-width: 750px) {
  .el-popper{
    width: calc(100% - 40px);
    left: 20px !important;
  }
  .el-cascader-node{
    padding: 5px 30px 5px 20px;
    height: auto;
    line-height: 1.25;
  }
  .el-cascader-node__label {
    padding: 0 10px;
    white-space: normal;
    overflow: visible;
    text-overflow: ellipsis;
  }
  .el-cascader-menu{
    min-width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/material.vue